import { useState, useCallback, useContext } from "react";
import {
  BASIC_AUTH_TOKKEN,
  LOGIN_ID,
  } from "../constants/LocalStorageKeyValuePairString";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { generateRequestId } from "../utils/RequestIdGenerator";
import { axiosInstance } from "../services/AxiosIntercepter";
import { ApiType } from "../services/ApiTags";
import { AuthContext } from "../context/AuthContext";

const useAxiosHook = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [showProgressBar, setProgressBar] = useState(false);
  const { authDetails } = useContext(AuthContext);

  const fetchData = useCallback(
    async (
      url,
      apiType,
      method = ApiType.POST_METHOD,
      encryptedData = null,
      options = {},
      callback
    ) => {
      // show progress bar
      setProgressBar(true);

      let requestData = {};
      if (apiType === ApiType.BASIC_AUTH) {
        // do nothing here
      } else if (apiType === ApiType.SIGN_IN) {
        // set login request content
        requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          //basicAuthToken: getFromLocalStorage(BASIC_AUTH_TOKKEN),
          contentDataObject: encryptedData,
        };
      } else if (apiType === ApiType.FORGOT_PASSWORD ) {
        // set login request content
        requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          basicAuthToken: getFromLocalStorage(BASIC_AUTH_TOKKEN),
          contentData: encryptedData,
        };
      } else if (apiType === ApiType.RESET_PASSWORD) {
        // set login request content
        requestData = {
          requestId: generateRequestId(),
          loginId: "",
          basicAuthToken: getFromLocalStorage(BASIC_AUTH_TOKKEN),
          contentData: encryptedData,
        };
      } 
      
      
      else {
        // set common request content
        requestData = {
          requestId: generateRequestId(),
          loginId:authDetails.loginId,
          sessionId:authDetails.sessionId,
          contentData: encryptedData,
          loginUserName:authDetails.name,
        };
      }

      try {
        const response = await axiosInstance({
          url,
          method,
          data: requestData,
          ...options,
        });
        setData(response.data);
        if (callback) {
          callback(response.data);
        }
      } catch (error) {
        // show error
        setError(error);
      } finally {
        // hide progress bar
        setProgressBar(false);
      }
    },
    []
  );

  return { data, error, showProgressBar, fetchData };
};

export default useAxiosHook;
